import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosNoAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  ACCOUNT_SESSION,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchAccountSession = async (payload) => {
  const customerId = payload?.custGid;
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosNoAuthInstance.get(`${API_END_POINTS.ACCOUNT_SESSION}/${customerId}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosNoAuthInstance.get(`${API_END_POINTS.ACCOUNT_SESSION}/${customerId}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosNoAuthInstance.get(`${API_END_POINTS.ACCOUNT_SESSION}/${customerId}${query}${sorting}`);
  }
  return axiosNoAuthInstance.get(`${API_END_POINTS.ACCOUNT_SESSION}/${customerId}${query}${sorting}`);
};

export function* getAccountSession(action) {
  yield put({ type: LOADING.SET });
  try {
    const { data: { entity } } = yield call(fetchAccountSession, action.payload);
    yield put({ type: ACCOUNT_SESSION.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ACCOUNT_SESSION.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

const fetchAccountSessionInvoices = async (searchParams) => {
  const { payload } = searchParams;
  // eslint-disable-next-line max-len
  return axiosNoAuthInstance.get(`${API_END_POINTS.ACCOUNT_SESSION_INVOICES}/${payload?.contactGid}?&sortBy=createdAt&direction=DESC&size=10&page=${payload.pageNo}`);
};

const fetchAccountSessionInvoiceDetails = async gid => axiosNoAuthInstance.get(`${API_END_POINTS.ACCOUNT_SESSION_VIEW_INVOICES}/${gid}`);

export function* getAccountSessionInvoices(action) {
  yield put({ type: LOADING.SET });
  try {
    const { data: { entity } } = yield call(fetchAccountSessionInvoices, action.payload);
    yield put({ type: LOADING.SET_SKELETON });
    yield put({ type: ACCOUNT_SESSION.SUCCESS_INVOICES, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ACCOUNT_SESSION.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
    yield put({ type: LOADING.UNSET_SKELETON });
  }
}
export function* getAccountSessionViewInvoices(action) {
  yield put({ type: LOADING.SET });
  try {
    const { data: { entity } } = yield call(fetchAccountSessionInvoiceDetails, action.payload);
    yield put({ type: LOADING.SET_SKELETON });
    yield put({ type: ACCOUNT_SESSION.SUCCESS_VIEW_INVOICES, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ACCOUNT_SESSION.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
    yield put({ type: LOADING.UNSET_SKELETON });
  }
}
